import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: true,
  selector: 'app-modal-project-register-submit',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-project-register-submit.component.html',
  styleUrls: ['./modal-project-register-submit.component.scss'],
})
export class ModalProjectRegisterSubmitComponent {
  @ViewChild('submitModal') submitModal?: ElementRef<B3ModalElement>;

  @Input() open = false;

  @Output() closed = new EventEmitter<boolean>();

  onCancel(): void {
    this.releaseModalOverlay();
    this.closed.emit(false);
  }

  onConfirm(): void {
    this.releaseModalOverlay();
    this.closed.emit(true);
  }

  onModalDismiss(): void {
    this.releaseModalOverlay();
    this.closed.emit(false);
  }

  private releaseModalOverlay(): void {
    const modalHost = this.submitModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });
  }
}
